class MobileNavigation extends HTMLElement {
  constructor() {
    super();
    this.toggleBtn = this.querySelector('.mobile-nav__toggle');
    this.drawer = this.querySelector('.mobile-nav__drawer');
    this.mainMenu = this.querySelector('.mobile-nav__main-menu');
    this.submenuBtns = this.querySelectorAll('.mobile-nav__link--has-children');
    this.backBtns = this.querySelectorAll('.mobile-nav__back');

    if (this.drawer) {
      this.drawer.addEventListener('toggle', this.onDrawerToggle.bind(this));
    }
    
    this.submenuBtns.forEach(btn => {
      btn.addEventListener('click', this.openSubmenu.bind(this));
    });

    this.backBtns.forEach(btn => {
      btn.addEventListener('click', this.closeSubmenu.bind(this));
    });
  }

  onDrawerToggle(event) {
    const isExpanded = event.newState === 'open';
    this.toggleBtn.setAttribute('aria-expanded', isExpanded);
    
    // Add class to header to manage transparent state on mobile
    const header = this.closest('header');
    if (header) {
      if (isExpanded) {
        header.classList.add('menu-open');
      } else {
        header.classList.remove('menu-open');
      }
    }

    // Reset state when closing
    if (!isExpanded) {
      this.resetSubmenus();
    }
  }

  openSubmenu(event) {
    const btn = event.currentTarget;
    const submenuId = btn.getAttribute('aria-controls');
    const submenu = this.querySelector(`#${submenuId}`);
    
    if (submenu) {
      this.mainMenu.classList.add('is-hidden');
      submenu.classList.add('is-active');
    }
  }

  closeSubmenu(event) {
    const btn = event.currentTarget;
    const submenu = btn.closest('.mobile-nav__submenu');
    
    if (submenu) {
      submenu.classList.remove('is-active');
      this.mainMenu.classList.remove('is-hidden');
    }
  }

  resetSubmenus() {
    this.mainMenu.classList.remove('is-hidden');
    this.querySelectorAll('.mobile-nav__submenu').forEach(submenu => {
      submenu.classList.remove('is-active');
    });
  }
}

customElements.define('mobile-navigation', MobileNavigation);
